import styled from 'styled-components';
import ICON_I_CLOUD from '@/assets/departureWifi/icon_iCloud.png';
import ICON_SWITCH from '@/assets/departureWifi/icon_switch.png';
import { ICON_CHEVRON_RIGHT_GRAY } from '@repo/assets';

function IosiCloud() {
  return (
    <WifiList>
      <WifiItem>
        <WifiDescription>1. 설정 -{'>'} iCloud</WifiDescription>
        <WifiName>
          <WifiNameLeft>
            <img src={ICON_I_CLOUD} alt='' width={16} />
            iCloud
          </WifiNameLeft>
          <Circle>
            <img src={ICON_CHEVRON_RIGHT_GRAY} alt='' width={24} />
          </Circle>
        </WifiName>
      </WifiItem>
      <WifiItem>
        <WifiDescription>2. 비공개 릴레이 OFF</WifiDescription>
        <WifiName>
          비공개 릴레이
          <img src={ICON_SWITCH} alt='' width={30} />
        </WifiName>
      </WifiItem>
    </WifiList>
  );
}

const WifiList = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 16px;
  border-radius: 12px;
  background-color: #f5f6f7;
`;

const WifiItem = styled.li`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

const WifiDescription = styled.dt`
  font-size: 12px;
  font-weight: 600;
  color: #3a3b3e;
  display: flex;
  align-items: center;

  & > img {
    margin: 0 4px;
  }
`;

const WifiName = styled.dd`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 12px;
  background-color: #ffffff;
  border-radius: 6px;
  font-size: 12px;
  color: #030303;
`;

const WifiNameLeft = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 15px;
`;

const Circle = styled.div`
  position: relative;
  &:after {
    content: '';
    width: 32px;
    height: 32px;
    border: 2px solid #ff2d55;
    border-radius: 40px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
`;

export default IosiCloud;
